import { Ionicons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import React, { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useTripInfoState } from 'src/common/hooks/states/useTripInfoState';
import { IconButton } from 'src/components';
import { pixelScaler } from 'src/themes/Metrics';
import { TripDetailModal } from '../../components/layout/TripDetailModal';

const SelectSeatView = React.lazy(() => import('./SelectSeatView'));

const SelectSeatScreen = () => {
  const { t } = useTranslation();
  const navigation = useNavigation();
  const { searchInfo, departureTripInfo } = useTripInfoState();
  // const { mutate } = useSocketSessionMutation();
  const [isVisible, setVisible] = React.useState(false);
  // const { params } = useRoute<RouteProp<DashboardStackParams, 'SelectSeatScreen'>>();

  React.useEffect(() => {
    // mutate();
  }, []);

  useLayoutEffect(() => {
    const selectSeatHeaderRight = () => (
      <IconButton
        icon={<Ionicons name="information-circle-outline" size={pixelScaler(24)} color="white" />}
        onPress={() => {
          setVisible(true);
        }}
      />
    );

    navigation.setOptions({
      headerRight: selectSeatHeaderRight,
      title: searchInfo?.returnDate ? t('selectSeatOption', { title: t('departureTrip') }) : t('selectSeat'),
    });
  }, []);

  const handleClose = () => setVisible(false);

  return (
    <React.Suspense>
      <SelectSeatView />
      {isVisible && (
        <TripDetailModal
          // isRoundTrip={searchInfo?.returnDate}
          isVisible={isVisible}
          onClose={handleClose}
          departureTripId={departureTripInfo?.tripId}
        />
      )}
    </React.Suspense>
  );
};

export default SelectSeatScreen;
